var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"block text-white text-center py-1 text-xs font-bold rounded",class:[_vm.placeThemeClass],attrs:{"data-test-id":_vm.id}},[_vm._v(" "+_vm._s(_vm.placeName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }